import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { PaginatedUserResult } from '../../common/classes';
import { IPaginatedResult, SmartsheetUser } from '../../common/interfaces';
import usersClient from '../../http-clients/UsersClient';
import { isDisabledContactPickerOnDemandSelector } from '../App/Selectors';

export const useSmartsheetUsers = () => {
    const [smartsheetUsers, setSmartsheetUsers] = useState<IPaginatedResult<SmartsheetUser>>(new PaginatedUserResult());
    const isDisabledContactPickerOnDemand = useSelector(isDisabledContactPickerOnDemandSelector);

    useEffect(() => {
        const getSmartsheetUsers = async (): Promise<void> => {
            try {
                const users = await usersClient.getUsers(isDisabledContactPickerOnDemand);
                setSmartsheetUsers(users);
            } catch {}
        };
        getSmartsheetUsers();
    }, [isDisabledContactPickerOnDemand]);

    return smartsheetUsers;
};
